export default {
    data() {
        return {
            deletedInlineIds: [],
        }
    },
    methods: {
        addItemInline(list, item, filterKey = null, filterValue = null) {
            if (!Array.isArray(list) || !item || !item.objectID) return false
            const index = list.findIndex(current => current.objectID === item.objectID)
            if (index !== -1) {
                list.splice(index, 1, { ...list[index], ...item })
                return true
            }
            if (filterKey && filterValue && item[filterKey] !== filterValue) return false
            list.unshift(item)
            return true
        },
        markDeletedInline(list, id) {
            if (!id) return Array.isArray(list) ? list : []
            if (!this.deletedInlineIds.includes(id)) this.deletedInlineIds.push(id)
            if (!Array.isArray(list)) return []
            return list.filter(current => current.objectID !== id)
        },
        filterDeletedInline(hits) {
            if (!Array.isArray(hits)) return []
            if (this.deletedInlineIds.length === 0) return hits
            return hits.filter(hit => !this.deletedInlineIds.includes(hit.objectID))
        },
    },
}
